export default __webpack_public_path__ + "static/media/tms.efb4c648.jpg";